import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Capacitor } from '@capacitor/core';

// Détecter si on est dans une app native (iOS/Android via Capacitor)
if (Capacitor.isNativePlatform()) {
  document.body.classList.add('native-app');
  document.body.classList.add(`platform-${Capacitor.getPlatform()}`); // 'ios' ou 'android'
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Register service worker for PWA offline support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('PWA: Content cached for offline use');
  },
  onUpdate: () => {
    console.log('PWA: New version available, refresh to update');
  }
});